import { getCurrentUser } from 'modules/data';
import { useProject } from 'modules/routes';
import { Modal } from 'modules/ui';
import { useSelector } from 'react-redux';

import RequestProjectAccessFormContainer from './RequestProjectAccessFormContainer';

/**
 * Opens access-request step two after confirmation on the originating project page.
 * @returns {React.ReactElement|null} Registration/access content when project settings are available.
 */
export default function AfterConfirmationPopup() {
    const currentUser = useSelector(getCurrentUser);
    const { project: currentProject, isLoading, error } = useProject();
    const currentProjectAccess =
        currentUser?.user_projects &&
        Object.values(currentUser.user_projects).find((up) => {
            return up.project_id === currentProject?.id;
        });

    if (!currentProject || isLoading || error) return null;

    const recentlyConfirmed =
        !currentUser?.admin &&
        currentProjectAccess?.workflow_state !== 'project_access_granted' &&
        !currentProjectAccess?.tos_agreement &&
        currentUser?.pre_register_location?.split('?')[0] ===
            location.origin + location.pathname &&
        !currentProject.is_umbrella &&
        !currentProject.grant_project_access_instantly &&
        !currentProject.grant_access_without_login;

    if (!recentlyConfirmed) return null;

    return (
        <Modal
            key="after-confirmation-popup"
            triggerClassName="Button Button--transparent Button--withoutPadding Button--primaryColor"
            showDialogInitially={true}
            hideButton={true}
        >
            {(close) => (
                <RequestProjectAccessFormContainer
                    onSubmit={close}
                    onCancel={close}
                    showStepTwo
                />
            )}
        </Modal>
    );
}
